import {$PositionProps, Position} from "../Position/Position";

export const RelativePosition = (props: $PositionProps) => {
  return (
    <Position
      {...props}
      className={"RelativePosition " + (props.className || "")}
      type="relative"
    >
      {props.children}
    </Position>
  );
};
